const styles = theme => ({
  sideBoxContainer: {
    // marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    maxWidth: 340
  },
  sideBoxCard: {
    // height: "100%",
    width: "100%",
    borderTop: "4px solid" + theme.palette.primary.light
  },
  titleContainer: {
    borderBottom: "2px #CCCCCC solid",
    marginBottom: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  cardTitle: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    color: theme.palette.primary.default
  },
  subTitle: {
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2)
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/SideBox/styles.js